export const GIFT_LP_URL = 'https://lp.wabunka-lux.jp/PurchaseGiftCards';
